'use client'

import * as blotout from 'components/analytics/blotout';
import * as gtm from 'components/analytics/gtm';
import useBlotout from 'components/hooks/use-blotout';
import useCustomAnalytics from 'components/hooks/use-custom-analytics';
import useGtm from 'components/hooks/use-gtm';
import { getCookie, hasCookie } from 'cookies-next';
import { updateViewedProductsCsv } from 'int-searchspring-api';
import { Product } from 'lib/bigcommerce/types';
import { useEffect } from 'react';
import { FunnelData } from 'shared-react-components';
import * as Intellisuggest from '../../ss-analytics/intellisuggest';

export function ProductEvents({ product, funnelData }: { product?: Product, funnelData?: FunnelData }) {
  useEffect(() => {
    const viewedProducts = hasCookie('ssViewedProducts') ? (getCookie('ssViewedProducts')?.toString() ?? '') : '';
    const viewedProductsUpdated = updateViewedProductsCsv(product?.id ?? '', viewedProducts);

    Intellisuggest.ProductView(process.env.NEXT_PUBLIC_SS_INDEX ?? '', getCookie('ssShopperId')?.toString() ?? '', product?.sku ?? '', product?.gid ?? '' );
  }, [product?.id, product?.sku, product?.gid]);

  useGtm({ funnelData, onReady: gtm.viewItem.bind(null, { product }) });
  useBlotout({ funnelData, onReady: blotout.viewItem.bind(null, { product }) });
  useCustomAnalytics({ funnelData });
  return null
}